// store.js
import React, {createContext, useReducer} from 'react';
import { reportReducer } from './report-reducer';
import { ApplicationState } from './ApplicationState';
import { initialApplicationState, initState } from './InitApplicationState';

const store = createContext<ApplicationState | null>(initialApplicationState);

// const store = createContext(context);
const { Provider } = store;

const useStore = () => {
  const value = React.useContext(store);
  if (!value) throw new Error("useStore needs to be within StateProvider");
  return value;
};

const StateProvider = ( { children} : any ) => {
  const [state, dispatch] = useReducer(reportReducer, initState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, useStore, StateProvider};
